import { render, staticRenderFns } from "./SelectBrandCollection.vue?vue&type=template&id=fbaedef6&scoped=true&"
import script from "./SelectBrandCollection.vue?vue&type=script&lang=js&"
export * from "./SelectBrandCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbaedef6",
  null
  
)

export default component.exports